import React, { useState, useEffect } from "react";
import Paper from "@material-ui/core/Paper";
import {
  Box,
  CircularProgress,
  IconButton,
  makeStyles,
} from "@material-ui/core";
import { FormattedMessage, useIntl } from "react-intl";

import {
  OpeningHoursAttributes,
  OpeningHoursMessageAttributes,
} from "../../../../attributes/opening-hours-attributes";
import { InputButton } from "../../../../components/input-button/InputButton";
import { FormikHelpers, useFormik } from "formik";
import * as Yup from "yup";
import OpeningHours from "../../../../models/OpeningHours";
import OpeningHoursService from "../../../../services/OpeningHoursService";
import BusinessBranchService from "../../../../services/BusinessBranchService";
import AddOpeningHours from "./modals/add_opening_hours/AddOpeningHours";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Alert from "@material-ui/lab/Alert";
import Button from "@material-ui/core/Button";
import { Delete } from "@material-ui/icons";

interface OpeningHoursTabProps {
  branch: number;
}

const useStyles = makeStyles(() => ({
  main: {
    minHeight: "75vh",
    overflow: "hidden",
    width: "100%",
    flexGrow: 1,
    paddingLeft: 30,
    paddingRight: 30,
    paddingTop: 20,
    paddingBottom: 20,
  },
  designTable: {
    tableLayout: "fixed",
    width: "57%",
    borderCollapse: "collapse",
    border: "1px solid blue",
    textAlign: "center",
    marginTop: -50,
  },
  designTh: {
    padding: "5px",
    width: "35%",
    fontFamily: "Rock Salt",
  },
  designTr: {
    borderCollapse: "collapse",
    border: "1px solid blue",
  },
  formatMessage: {
    fontFamily: "Georgia",
  },
  designDayWeek: {
    width: "50%",
  },
  hourStyle: {
    listStyleType: "none",
    lineHeight: "2",
    marginLeft: 30,
  },
  btnMove: {
    borderWidth: 1,
    alignItems: "center",
    justifyContent: "center",
    width: 15,
    height: 15,
    backgroundColor: "#DC143C",
    borderRadius: "50%",
  },
  title: {
    fontSize: 24,
    marginTop: 5,
    marginLeft: 30,
  },
  deleteButton: {
    verticalAlign: "right",
    position: "relative",
    //position: "absolute",
    top: "50%",
    textAlign: "right",
    msTransform: "translateY(5%)",
    transform: "translateY(5%)",
    marginLeft: 50,
  },
  alertSucces: {
    marginLeft: 30,
  },
  saveButton: {
    marginLeft: 30,
    marginTop: 25,
    marginBottom: 25,
  },
}));

export const OpeningHoursTab = (props: OpeningHoursTabProps) => {
  const classes = useStyles();
  const { branch } = props;
  const [openingHours, setOpeningHours] = useState(
    (): Array<OpeningHours> => []
  );
  const [openingHoursMessages, setOpeningHoursMessages] = useState(
    (): Array<OpeningHoursMessageAttributes> => []
  );
  const [
    isAddOpeningHoursModalOpened,
    setIsAddOpeningHoursModalOpened,
  ] = useState(false);
  const [succeed, setSucceed] = useState(false);
  const [timeOfStop, setTimeOfStop] = useState(true);

  const intl = useIntl();
  const initFormValues = (): OpeningHoursAttributes => {
    return {
      day_id: 1,
      opening_hour: "",
      closing_hour: "",
    };
  };

  const formValidation = () => {
    return {
      day_id: Yup.number().required(intl.formatMessage({ id: "error.dayId" })),
      opening_hour: Yup.string().required(
        intl.formatMessage({ id: "error.openingHours" })
      ),
      closing_hour: Yup.string().required(
        intl.formatMessage({ id: "error.closingHours" })
      ),
    };
  };

  const toggleAddOpeningHourModal = (succeed: boolean = false) => {
    setIsAddOpeningHoursModalOpened(!isAddOpeningHoursModalOpened);
    if (succeed) {
      getData();
    }
  };

  const getDay = (id: number) => {
    let day: string;
    for (let cpt = 0; cpt < openingHoursMessages.length; cpt++) {
      if (openingHoursMessages[cpt].day_id == id) {
        day = openingHoursMessages[cpt].message;
      }
    }
    return day;
  };

  const addOpeningHour2 = (openingHour: OpeningHours) => {
    openingHour.day = getDay(openingHour.day_id);
    let openingHoursNew = [...openingHours];
    let searchIndex: number = -1;

    for (let index = 0; index < openingHoursNew.length; index++) {
      if (openingHoursNew[index].day_id === openingHour.day_id) {
        searchIndex = index;
        break;
      }
    }

    if (searchIndex >= 0) {
      let old = openingHoursNew[searchIndex];
      openingHour.id = old.id;
      openingHoursNew[searchIndex] = openingHour;
    } else {
      openingHoursNew.push(openingHour);
    }

    setOpeningHours(openingHoursNew);
    formik.setValues(initFormValues());
  };

  const applyOpeningHoursCreation = (event: any) => {
    if (openingHours.length > 0) {
      let requestData = {
        business_branch_id: branch,
        hours: openingHours,
      };
      OpeningHoursService.createOpeningHours(requestData).then((response) => {
        if (response.isSuccess && response.data.code === 100) {
          setSucceed(true);
          setTimeout(() => {
            setSucceed(false);
          }, 2000);
          let openingHours: Array<OpeningHours> = [];

          JSON.parse(JSON.stringify(response.data.data)).forEach(
            (item, index) => {
              openingHours.push(
                OpeningHours.fromJson(item as OpeningHoursAttributes)
              );
            }
          );
          setOpeningHours(openingHours);
          console.dir(openingHours);
        }
      });
    }
  };

  const formik = useFormik({
    initialValues: initFormValues(),
    validationSchema: Yup.object().shape({
      ...formValidation(),
    }),
    onSubmit: async (
      values: any,
      { setErrors, setSubmitting }: FormikHelpers<any>
    ) => {},
  });

  const handleDelete = (id) => {
    {
      const openingHoursCopy = [...openingHours];
      const openingHoursCopyUpdated = openingHoursCopy.filter(
        (openingHour) => openingHour.day_id !== id
      );
      setOpeningHours(openingHoursCopyUpdated);
    }
  };

  const getData = () => {
    BusinessBranchService.getOpeningHours(branch).then((response) => {
      if (response.isSuccess && response.data.code === 100) {
        let openingHours: Array<OpeningHours> = [];
        let openingHoursMessages: Array<OpeningHoursMessageAttributes> = [];
        const data = JSON.parse(JSON.stringify(response.data.data));

        data.hours.forEach((item, index) => {
          openingHours.push(
            OpeningHours.fromJson(item as OpeningHoursAttributes)
          );
        });
        data.messages.forEach((item, index) => {
          openingHoursMessages.push(item);
        });
        setOpeningHours(openingHours);
        setOpeningHoursMessages(openingHoursMessages);
      }
    });
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <Paper className={classes.main} elevation={3}>
      {isAddOpeningHoursModalOpened && (
        <AddOpeningHours
          branch={branch}
          isOpened={isAddOpeningHoursModalOpened}
          closeCallback={toggleAddOpeningHourModal}
          onSaveOpeningHour={addOpeningHour2}
        />
      )}
      <Grid item xs={12} sm={6} lg={12} container justify="flex-end">
        <InputButton
          onClick={() => toggleAddOpeningHourModal()}
          color="secondary"
          variant="contained"
        >
          + <FormattedMessage id="sharedScreen.addOpeningHoursBusiness" />
        </InputButton>
      </Grid>
      <Grid item xs={12} sm={12} lg={12}>
        <Box
          mt={10}
          display="flex"
          alignItems="center"
          justifyContent="flex-start"
        >
          <Grid item xs={12} sm={6} lg={12}>
            <div className={classes.hourStyle}>
              <div>
                <table className={classes.designTable}>
                  <tr>
                    <th className={classes.designTh}>
                      <div>
                        <FormattedMessage id="sharedScreen.openingHoursDay" />
                      </div>
                    </th>
                    <th>
                      <div>
                        <FormattedMessage id="sharedScreen.openingHoursOpening" />
                      </div>
                    </th>
                    <th>
                      <div>
                        <FormattedMessage id="sharedScreen.openingHoursClosing" />
                      </div>
                    </th>
                    <th>
                      <div>
                        <FormattedMessage id="sharedScreen.openingHoursAction" />
                      </div>
                    </th>
                  </tr>
                  {openingHours.length === 0 && timeOfStop === false && (
                    <div className="progressWrapper">
                      <Box component="span" className="loader"></Box>
                    </div>
                  )}
                  {openingHours.length === 0 && (
                    <tr>
                      <td colSpan={4}>
                        <Alert severity="info">
                          <FormattedMessage id="sharedScreen.messageTableEmpty" />
                        </Alert>
                      </td>
                    </tr>
                  )}
                  {openingHours.map((openingHour) => (
                    <tr className={classes.designTr}>
                      <td> {openingHour.day}</td>
                      <td>{openingHour.opening_hour}</td>
                      <td>{openingHour.closing_hour}</td>
                      <td>
                        <Grid
                          className={classes.deleteButton}
                          item
                          xs={2}
                          sm={2}
                          lg={1}
                        >
                          <IconButton
                            title={intl.formatMessage({
                              id: "sharedScreen.openningHourDelete",
                            })}
                            aria-label="delete"
                            size="medium"
                            onClick={() => handleDelete(openingHour.day_id)}
                          >
                            <Delete fontSize="inherit" color="error" />
                          </IconButton>
                        </Grid>
                      </td>
                    </tr>
                  ))}
                </table>
              </div>
            </div>
          </Grid>
        </Box>

        <Grid item xs={3} sm={1} lg={1} className={classes.saveButton}>
          <InputButton
            color="secondary"
            fullWidth
            size="medium"
            variant="contained"
            type="button"
            onClick={applyOpeningHoursCreation}
            disabled={openingHours.length <= 0}
          >
            <FormattedMessage id="sharedScreen.saveOpeningHour" />
            {succeed && <CircularProgress color="inherit" size={25} />}
          </InputButton>
        </Grid>

        {succeed && (
          <Grid item xs={6} sm={4} lg={7}>
            <Alert severity="success" className={classes.alertSucces}>
              <FormattedMessage id="sharedScreen.openningHourCreatedSuccessfully" />
            </Alert>
          </Grid>
        )}
        <Grid item xs={6} sm={4} lg={7}>
          <Typography className={classes.title} variant="h4" component="h4">
            <Alert severity="info">
              <FormattedMessage id="sharedScreen.messageOpeningHours" />
            </Alert>
          </Typography>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default OpeningHoursTab;
